var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-info-wrap" }, [
    !_vm.isLogin
      ? _c("div", { staticClass: "user-info-item login-before" }, [
          _c("p", { staticClass: "s-txt" }, [
            _vm._v(" 닥터인포에 로그인하여 "),
          ]),
          _c("p", { staticClass: "b-txt" }, [
            _vm._v(" 이달의 미션 포인트를 쌓아보세요! "),
          ]),
          _c(
            "button",
            {
              staticClass: "btn-login",
              on: {
                click: function ($event) {
                  return _vm.login()
                },
              },
            },
            [_vm._v(" 로그인 ")]
          ),
        ])
      : _vm._e(),
    _vm.isLogin
      ? _c("div", { staticClass: "user-info-item login-after" }, [
          _c("p", { staticClass: "s-txt" }, [_vm._v(" 환영합니다! ")]),
          _c("p", { staticClass: "b-txt" }, [
            _c("span", { staticClass: "user-name" }, [
              _vm._v(_vm._s(_vm.userName)),
            ]),
            _vm._v("선생님의 보유 포인트 "),
          ]),
          _c("p", { staticClass: "user-point" }, [
            _c("span", { staticClass: "point" }, [
              _vm._v(_vm._s(_vm._f("$numberFormatter")(_vm.userPoint))),
            ]),
            _c("em", [_vm._v("P")]),
          ]),
        ])
      : _vm._e(),
    _c("hr", { staticClass: "line-1" }),
    _c("div", { staticClass: "user-info-item mission-wrap" }, [
      _c("h3", [_vm._v("이달의 미션")]),
      _c("ul", [
        _c("li", { staticClass: "medical-type" }, [
          _c("span", { staticClass: "left-col" }, [
            _c("span", { staticClass: "mission-type" }, [
              _vm._v("메디컬 트렌드"),
            ]),
            _c("span", { staticClass: "mission-goal" }, [
              _vm._v("댓글 " + _vm._s(_vm.mediReply.goal) + "개 작성"),
            ]),
          ]),
          _c("span", { staticClass: "right-col" }, [
            _vm.isLogin
              ? _c("span", { staticClass: "mission-status" }, [
                  _c("em", [_vm._v(_vm._s(_vm.mediReply.my))]),
                  _vm._v(" / " + _vm._s(_vm.mediReply.goal)),
                ])
              : _vm._e(),
            _c("span", { staticClass: "mission-point" }, [
              _vm._v(_vm._s(_vm._f("$numberFormatter")(_vm.mediReply.point))),
              _c("em", [_vm._v("P")]),
            ]),
          ]),
        ]),
        _c("li", { staticClass: "seminar-type" }, [
          _c("span", { staticClass: "left-col" }, [
            _c("span", { staticClass: "mission-type" }, [_vm._v("웹세미나")]),
            _c("span", { staticClass: "mission-goal" }, [
              _vm._v(_vm._s(_vm.webinarView.goal) + "회 일정 등록"),
            ]),
          ]),
          _c("span", { staticClass: "right-col" }, [
            _vm.isLogin
              ? _c("span", { staticClass: "mission-status" }, [
                  _c("em", [_vm._v(_vm._s(_vm.webinarView.my) + " ")]),
                  _vm._v(" / " + _vm._s(_vm.webinarView.goal)),
                ])
              : _vm._e(),
            _c("span", { staticClass: "mission-point" }, [
              _vm._v(_vm._s(_vm._f("$numberFormatter")(_vm.webinarView.point))),
              _c("em", [_vm._v("P")]),
            ]),
          ]),
        ]),
        _c("li", { staticClass: "weekly-type" }, [
          _c("span", { staticClass: "left-col" }, [
            _c("span", { staticClass: "mission-type" }, [
              _vm._v("Weekly Choice"),
            ]),
            _c("span", { staticClass: "mission-goal" }, [
              _vm._v(_vm._s(_vm.wChoice.goal) + "회 참여"),
            ]),
          ]),
          _c("span", { staticClass: "right-col" }, [
            _vm.isLogin
              ? _c("span", { staticClass: "mission-status" }, [
                  _c("em", [_vm._v(_vm._s(_vm.wChoice.my))]),
                  _vm._v(" / " + _vm._s(_vm.wChoice.goal)),
                ])
              : _vm._e(),
            _c("span", { staticClass: "mission-point" }, [
              _vm._v(_vm._s(_vm._f("$numberFormatter")(_vm.wChoice.point))),
              _c("em", [_vm._v("P")]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c("hr", { staticClass: "line-1" }),
    _c(
      "div",
      {
        staticClass: "user-info-item survey-wrap",
        on: {
          click: function ($event) {
            return _vm.link("app-survey-main")
          },
        },
      },
      [
        _c("h3", [_vm._v("참여 가능한 설문조사")]),
        _c("span", { staticClass: "survey-status" }, [
          _vm._v(_vm._s(_vm.surveyCount)),
          _c("em", [_vm._v("건")]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }